import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { TitleOfferLightFragmentDoc } from '../../../buybox/graphql/fragments/Offer.fragment';
export type AdServerSqtvCreativeFragment = {
	__typename: 'CreativeSQTVContent';
	offerSource?: Types.OfferSource | null;
	similarityScore: number;
	similarTitle: {
		__typename: 'AdSimilarTitle';
		id: string;
		objectId: number;
		objectType: Types.ObjectType;
		content: {
			__typename: 'AdSimilarTitleContent';
			title: string;
			posterUrl?: string | null;
			backdrops: Array<{ __typename: 'Backdrop'; backdropUrl: string }>;
			scoring?: {
				__typename: 'Scoring';
				imdbVotes?: number | null;
				imdbScore?: number | null;
				tomatoMeter?: number | null;
				certifiedFresh?: boolean | null;
				jwRating?: number | null;
			} | null;
			interactions: { __typename: 'InteractionAttributes'; votesNumber: number };
			genres: Array<{ __typename: 'Genre'; translation: string }>;
			tags: Array<{ __typename: 'Tag'; technicalName: string; translatedName: string }>;
		};
		offers: Array<{
			__typename: 'Offer';
			id: string;
			monetizationType: Types.MonetizationType;
			presentationType: Types.PresentationType;
			standardWebURL?: string | null;
			package: {
				__typename: 'Package';
				id: string;
				packageId: number;
				clearName: string;
				shortName: string;
				icon: string;
				iconWide: string;
				technicalName: string;
			};
		}>;
	};
};

export const AdServerSqtvCreativeFragmentDoc = gql`
	fragment AdServerSQTVCreative on CreativeSQTVContent {
		offerSource
		similarityScore
		similarTitle {
			id
			objectId
			objectType
			content {
				title
				posterUrl
				backdrops(limit: 1) {
					backdropUrl
					__typename
				}
				scoring {
					imdbVotes
					imdbScore
					tomatoMeter
					certifiedFresh
					jwRating
					__typename
				}
				interactions {
					votesNumber
					__typename
				}
				genres {
					translation(language: $language)
					__typename
				}
				tags {
					technicalName
					translatedName
					__typename
				}
				__typename
			}
			offers(country: $country, platform: $platform) {
				...TitleOfferLight
				__typename
			}
			__typename
		}
		__typename
	}
	${TitleOfferLightFragmentDoc}
`;
